import { requestFromServer } from "./api-client";

const Clients = {
  getById: async (id) => {
    return requestFromServer(`v1/Clients/get/${id}`);
  },
  getByDocument: async (payload) => {
    const documentNumber = payload.documentNumber ?? payload;
    const includeFarms = payload.includeFarms ?? 0;
    return requestFromServer(
      `v1/Clients/getByDocument?clientDocument=${documentNumber}&includeFarms=${includeFarms}`
    );
  },
  getUserClients: async (id) => {
    return requestFromServer(`v1/Clients/getUserClients`);
  },
  getByNickname: async (nickname) => {
    return requestFromServer(`v1/Clients/getByNickname/${nickname}`);
  },
  searchByDocument: async (document) => {
    return requestFromServer("v1/Clients/searchByDocument", "POST", { document });
  }
};

export default Clients;
